module.exports = __webpack_public_path__ + "img/im_banner.f189a65a.png";